import useDisplayPreferences from "./useDisplayPreferences";

export default function useUnitSystem() {
  const { system, locale, currency } = useDisplayPreferences();
  return { system, locale, currency };
}
